import React, { useState, useEffect }  from 'react';
import QuoteBuilderForm from 'components/quote_builder/QuoteBuilderForm.jsx';
import SettingsUserUnitPriceAttributeList from 'components/quote_builder/SettingsUserUnitPriceAttributeList.jsx';

const SettingsTabs = ( { config, breadcrumbs, showingState, afterSave, afterCancel, editStateId, hideDeleteFromList, editId, showNewForm, activeTab, onTabChange } ) => {
  const unit = window.user_unit || 'mm'

  // Use editId from props if provided (from URL), otherwise use editStateId
  const effectiveEditStateId = editId || editStateId;
  // Determine showing state: 'new' if showNewForm, 'edit' if editId, otherwise use passed showingState
  const effectiveShowingState = showNewForm ? 'new' : (editId ? 'edit' : showingState);

  const tabsConfig = config.tabs;
  if(tabsConfig == undefined) { return <QuoteBuilderForm
    config={config}
    showingState={effectiveShowingState}
    afterSave={afterSave}
    afterCancel={afterCancel}
    editStateId={effectiveEditStateId}
    hideDeleteFromList={hideDeleteFromList}
    showNewForm={showNewForm}
  />}

  const initialTabIndex = () => {
    if (!activeTab || !tabsConfig) { return 0; }
    const index = tabsConfig.findIndex(tab => tab.key === activeTab);
    return index >= 0 ? index : 0;
  };

  const [tabIndex, setTabIndex] = useState(initialTabIndex)
  const _setTabIndex = (e, i) => {
    e.preventDefault();
    setTabIndex(() => i)
    if (onTabChange) {
      const tabKey = (tabsConfig[i] && tabsConfig[i].key) || null;
      onTabChange(tabKey);
    }
  }

  // Sync tab index when activeTab changes (e.g. browser back/forward)
  useEffect(() => {
    if (!tabsConfig) { return; }
    if (activeTab) {
      const index = tabsConfig.findIndex(tab => tab.key === activeTab);
      setTabIndex(index >= 0 ? index : 0);
    } else {
      setTabIndex(0);
    }
  }, [activeTab])

  const getTab = (tab, i) => {
    return <li role="presentation" class={tabIndex == i ? 'active' : ''}> <a href="#" onClick={ (e) => _setTabIndex(e, i) }> { tabTitle( tabsConfig[i] ) } </a> </li>
  }


  const UserUnitPriceAttributesByUnitContent = () => {
    const tabConfig = tabsConfig[ tabIndex ];

    return <>
      {tabConfig.attributes.map( (attributeConfig) => {
        return unit == attributeConfig.unit && <SettingsUserUnitPriceAttributeList userUnitPriceKey={config.key} tabConfig={attributeConfig} />
      } ) }
    </>
  }

  const tabContent = () => {
    const tabConfig = tabsConfig[ tabIndex ];

    switch(tabConfig.form_type) {
    case "UserUnitPrices":
      return <QuoteBuilderForm
        config={config}
        showingState={effectiveShowingState}
        afterSave={afterSave}
        afterCancel={afterCancel}
        editStateId={effectiveEditStateId}
        hideDeleteFromList={hideDeleteFromList}
        showNewForm={showNewForm}
        />
      break;

    case "UserUnitPriceAttribute":
      return <SettingsUserUnitPriceAttributeList userUnitPriceKey={config.key} tabConfig={tabConfig} />
      break;

     case "UserUnitPriceAttributesByUnit":
      return UserUnitPriceAttributesByUnitContent()
      break;

    default:
      throw "[error] tabContent cannot be found for " + tabConfig.form_type;
    }

    return <>

    </>
  }

  const tabTitle = (tabConfig) => {
    switch(tabConfig.form_type) {
    case "UserUnitPrices":
      return t("quote_builder.my_unit_prices");
      break;

    case "UserUnitPriceAttribute":
      return t(tabConfig.label)
      break;

    case "UserUnitPriceAttributesByUnit":
      return t(tabConfig.label)
      break;

    default:
      throw "[error] tabTitle cannot be found for " + tabConfig.form_type;
    }
  }

  const breadcrumbHeader = () => {
    if(breadcrumbs == undefined) { return }
    return <><div className="page-in-name"> {breadcrumbs.split(",").map( (br) => t("quote_builder." + br)  ).join(" | ") } </div> <hr /></>
  }
  return (
    <div>
      {breadcrumbHeader()}
      <ul class="nav nav-pills">
        { config.tabs != undefined && config.tabs.map(getTab) }
      </ul>

      <div key={tabIndex} style={{marginTop: "10px"}}> {tabContent()} </div>
    </div>
  )
}

export default SettingsTabs;
